import styled from 'styled-components';


export const StyledCategoriesContainer = styled.div`
  margin-top: 16px;
`;
